import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import MarketingForSchoolsApp from "./ShotByU";

// Initialize Sentry Error Tracking
// Only tracks errors in production (not local development)
Sentry.init({
  dsn: "https://0f325508df14825041db79ec87ab01a2@o4510334772576256.ingest.de.sentry.io/4510334778671184",

  // Only track errors in production (not localhost)
  enabled: import.meta.env.PROD,

  // Environment (production, staging, development)
  environment: import.meta.env.MODE,

  // Performance Monitoring
  integrations: [
    Sentry.browserTracingIntegration(),
    // Replay integration removed to reduce bundle size (16 KiB savings)
    // Error tracking still works, just without session replay videos
  ],

  // Performance monitoring sample rate (10% of pageviews)
  tracesSampleRate: 0.1,

  // Filter out noise
  beforeSend(event) {
    // Ignore browser extension errors
    if (event.exception?.values?.[0]?.value?.includes('extension')) {
      return null;
    }
    return event;
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="p-8 text-center font-sans">
          <h1 className="text-red-600 mb-4">Oops! Something went wrong</h1>
          <p className="text-gray-500 mb-6">
            We've been notified of the issue and are working on a fix.
          </p>
          <button
            onClick={resetError}
            className="px-6 py-3 bg-amber-500 text-white rounded-lg text-base font-semibold cursor-pointer hover:bg-amber-600 transition-colors"
          >
            Try Again
          </button>
          <details className="mt-8 text-left max-w-2xl mx-auto">
            <summary className="cursor-pointer text-gray-500">Error details</summary>
            <pre className="mt-4 p-4 bg-gray-100 rounded-lg overflow-auto text-sm">
              {error?.toString()}
            </pre>
          </details>
        </div>
      )}
      showDialog
    >
      <MarketingForSchoolsApp />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
